<template>
    <div>
        <md-cell-item title="IToken">
            <template slot="right">
                <p>{{ u.amount }}</p>
                <p>
                    <pointtext :text="u.purpose" type="success" v-if="get_type_color(u.purpose) === 'success'">
                    </pointtext>
                    <pointtext :text="u.purpose" type="notline" v-if="get_type_color(u.purpose) === 'warning'">
                    </pointtext>
                    <pointtext :text="u.purpose" type="fail" v-if="get_type_color(u.purpose) === 'fail'">
                    </pointtext>
                </p>
            </template>
            <template slot="default">
                <p class="mtime">Remark: {{ u.remark }}</p>
                <p class="mtime">{{ u.mtime }}</p>
                <p class="mtime" style="color: burlywood;" @click="showdetail">related record</p>
            </template>
        </md-cell-item>

        <md-dialog class="detail" title="Related record" :closable="false" v-model="detailopen" :btns="btns">
            <md-field>
                <md-detail-item title="Itoken" :content="u.amount" bold />
                <md-detail-item title="Type" :content="u.type" />
                <md-detail-item title="Orderno" :content="u.orderno ? u.orderno : 'NA'" />
                <md-detail-item title="Kyc Partner" :content="u.ct_type ? u.ct_type : 'NA'" />
                <md-detail-item title="UPI ID" :content="u.upiid ? u.upiid : 'NA'" />
                <md-detail-item title="Utr" :content="u.bill_utr ? u.bill_utr : 'NA'" />
                <md-detail-item title="Remark" :content="u.remark" />
                <md-detail-item title="Time" :content="u.ctime" />
                <md-detail-item title="Related record" bold
                    v-if="u.type === 'deducted' || u.type === 'return' || u.type === 'add' || u.type === 'admindeducted'">
                    <a href="javascript:;" style="color:#5878B4;text-decoration:none;" @click="check_detai">Check</a>
                </md-detail-item>
                <div v-if="check">
                    <div v-for="i in detail" v-bind:key="i.id">
                        <md-detail-item class="detail-title" :title="i.type" :content="i.amount + ' IToken'" />
                        <md-detail-item :content="i.remark" />
                    </div>
                </div>
            </md-field>
        </md-dialog>
    </div>
</template>

<script>
import iconimg from '@/components/iconimg'
import pointtext from '@/components/pointtext'
import { getassetsrecord } from '@/request/api'
import topback from '@/components/topback'

export default {
    name: 'itokenhisoryitem',
    props: {
        u: {
            type: Object,
            default: {}
        },
        dropdata: {
            type: Array,
            default: []
        }
    },
    components: {
        iconimg,
        pointtext,
        topback,
    },
    data() {
        return {
            check: false,
            detailopen: false,
            btns: [
                {
                    text: 'Close',
                },
            ],
            detail: []
        }
    },
    created() {
    },
    methods: {
        showdetail() {
            this.detailopen = true;
        },
        check_detai() {
            this.$toast.loading("Loading...");
            let filter_params = {}
            if (this.u.orderno) {
                filter_params.orderno = this.u.orderno
            }
            if (this.u.utr) {
                filter_params.utr = this.u.utr
            }
            getassetsrecord(filter_params).then(res => {
                this.$toast.hide();
                if (res.code === 200) {
                    this.detail = res.data.result;
                    this.check = true;
                } else {
                    this.$toast.failed(res.errmsg);
                }
            })
        },
        get_type_color(type) {
            let success_list = ["recharge", "return", "adminadd", "transferin"]
            let red_list = ["deducted", "admindeducted", "transferout", "fee"]
            let warning_list = ["reward", "commission"]
            if (success_list.indexOf(type) !== -1) {
                return "success";
            }
            if (red_list.indexOf(type) !== -1) {
                return "fail";
            }
            if (warning_list.indexOf(type) !== -1) {
                return "warning"
            }
            return "pending"
        },
        display_type(type) {
           // console.log("this.dropdata", this.dropdata)
            // let options = this.dropdata[0].options;
            // let foundOption = options.find(option => option.value === type);
            // return foundOption.text;
            return "type";
        }
    }
}
</script>
<style scoped>
.mtime {
    color: #666;
    font-size: 24px;
}

.detail>>>.md-dialog-body {
    color: #666f83;
    font-size: 0.28rem;
    text-align: left;
    padding: 0.12rem 0.22rem !important;
}

.detail-title>>>.md-detail-title {
    color: red;
    font-size: 0.32rem;
}
</style>



// WEBPACK FOOTER //
// src/views/my/itokenhisoryitem.vue